import styled from '@emotion/styled'

import { Spacing } from '../../../../enums/spacing'
import { pxToNumber } from '../../../../utils/pxToNumber'

interface TableRowExpanderWrapperProps {
  selectable: boolean
}

export const TableRowExpanderWrapper = styled.button<TableRowExpanderWrapperProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  position: absolute;
  left: ${({ selectable }) => (selectable ? `${pxToNumber(Spacing.S16) * 2}px` : Spacing.S16)};
  cursor: pointer;
`
